
import {useAxios} from './';
import moment from 'moment';

const useProdutos = () => {
    const {getApiEmitirNotas} = useAxios();

    const listarProdutosEstoque = async (termo, dataLimite) => {
        const api = await getApiEmitirNotas();
        const result = await api.get('/produtos/v2', {
            params: {
                termo, 
                dataLimite, 
                tipoProduto: "MATERIA_PRIMA,SIMPLES"
            }
        });
        return result.data;
    }

    const listarEstoqueProdutoPorLote = async (termo, dataLimite = (moment().format("YYYY-MM-DD"))) =>{
        const api = await getApiEmitirNotas();
        const result = await api.get('/produtos/v2', {
            params: {termo, dataLimite, groupBy: "lote"}
        });
        return result.data;
    }

    const buscaHistoricoMovimentacoes = async (produto, inicio="", fim="") =>{
        const api = await getApiEmitirNotas();
        const data = {
            params: {}
        };
        if(inicio){
            data.params.inicio = inicio.format("YYYY-MM-DD")
        }

        if(fim){
            data.params.fim = fim.format("YYYY-MM-DD")
        }
        const result = await api.get('/movimentacao-estoque/' + produto.uuid + '/historico', data);
        return result.data;
    }

    const adicionarSaldo = async (movimentacao) =>{
        const api = await getApiEmitirNotas();
        const result = await api.post('/movimentacao-estoque/', movimentacao);
        return result.data;
    }


    return {listarProdutosEstoque, listarEstoqueProdutoPorLote, buscaHistoricoMovimentacoes, adicionarSaldo};
}

export {useProdutos}